function Letter(props) {
  return (
    <div className="square" data-state={props.colour}>
      {props.letter}
    </div>
  );
}

export default Letter;